
// src/redux/actions/authActions.js
import { LOGIN, LOGOUT } from "../actionTypes";

export const login = (username) => {
  return {
    type: LOGIN,
    payload: { name: username }
  };
};

export const logout = () => {
  return {
    type: LOGOUT,
  };
};





